module.exports = __webpack_public_path__ + "static/the-age-of-wonder-4ad689e3c97cd53a9cea4115d519da9d.jpg";